//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/cssVars/cssVarsParser.js
var e = (e, t, n, r = []) => {
	let i = e;
	t.forEach((e, a) => {
		a === t.length - 1 ? Array.isArray(i) ? i[Number(e)] = n : i && typeof i == "object" && (i[e] = n) : i && typeof i == "object" && (i[e] || (i[e] = r.includes(e) ? [] : {}), i = i[e]);
	});
}, t = (e, t, n) => {
	function r(e, i = [], a = []) {
		Object.entries(e).forEach(([e, o]) => {
			(!n || n && !n([...i, e])) && o != null && (typeof o == "object" && Object.keys(o).length > 0 ? r(o, [...i, e], Array.isArray(o) ? [...a, e] : a) : t([...i, e], o, a));
		});
	}
	r(e);
}, n = (e, t) => typeof t == "number" ? [
	"lineHeight",
	"fontWeight",
	"opacity",
	"zIndex"
].some((t) => e.includes(t)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function r(r, i) {
	let { prefix: a, shouldSkipGeneratingVar: o } = i || {}, s = {}, c = {}, l = {};
	return t(r, (t, r, i) => {
		if ((typeof r == "string" || typeof r == "number") && (!o || !o(t, r))) {
			let o = `--${a ? `${a}-` : ""}${t.join("-")}`, u = n(t, r);
			Object.assign(s, { [o]: u }), e(c, t, `var(${o})`, i), e(l, t, `var(${o}, ${u})`, i);
		}
	}, (e) => e[0] === "vars"), {
		css: s,
		vars: c,
		varsWithDefaults: l
	};
}
//#endregion
export { r as default };

//# sourceMappingURL=index74.js.map